import { render } from "./RequestMaterial.vue?vue&type=template&id=b4182206"
import script from "./RequestMaterial.vue?vue&type=script&lang=js"
export * from "./RequestMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__